import { render } from "./WorkSpaceSwitcher.vue?vue&type=template&id=3da4f05a&scoped=true"
import script from "./WorkSpaceSwitcher.vue?vue&type=script&lang=js"
export * from "./WorkSpaceSwitcher.vue?vue&type=script&lang=js"

import "./WorkSpaceSwitcher.vue?vue&type=style&index=0&id=3da4f05a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da4f05a"]])

export default __exports__